import { render, staticRenderFns } from "./project.component.vue?vue&type=template&id=32abbeba&scoped=true&"
import script from "./project.component.vue?vue&type=script&lang=js&"
export * from "./project.component.vue?vue&type=script&lang=js&"
import style0 from "./project.component.vue?vue&type=style&index=0&id=32abbeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abbeba",
  null
  
)

export default component.exports